import React from 'react'

import {useParams, useNavigate} from "react-router-dom";
import InactivityLogout from '../services/InactivityLogout';
import Header from '../components/Header'
import ProductPermissionSection from '../components/productPermissionSection'



export default function ProductsPermission() {

    const {email} = useParams();
    const navigate = useNavigate();
       
    return (
        <>
                <InactivityLogout>
                <Header searchterm={email} />
                <ProductPermissionSection searchterm={email} navigate={navigate} />
                </InactivityLogout>
        </>
    );
}